import { render, staticRenderFns } from "./FintechInitial.vue?vue&type=template&id=11390a55&"
import script from "./FintechInitial.vue?vue&type=script&lang=js&"
export * from "./FintechInitial.vue?vue&type=script&lang=js&"
import style0 from "./FintechInitial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports